import Vue from "vue";
import VuePageTitle from "vue-page-title";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import NProgress from "vue-nprogress";
import { i18n } from "@/localization";
import BootstrapVue from "bootstrap-vue";
import {
  Avatar,
  TreeSelect,
  Rate,
  Breadcrumb,
  InputNumber,
  Steps,
  Message,
  Upload,
  Button,
  Layout,
  Table,
  Icon,
  Progress,
  Radio,
  Dropdown,
  Menu,
  Carousel,
  Input,
  Calendar,
  Badge,
  Slider,
  Form,
  Tooltip,
  Select,
  Switch,
  Tag,
  Affix,
  Spin,
  Alert,
  Checkbox,
  Tabs,
  Pagination,
  notification,
  Drawer,
  Cascader,
  DatePicker,
  TimePicker,
  Divider,
  Anchor,
  AutoComplete,
  BackTop,
  Collapse,
  Card,
  List,
  Popover,
  Tree,
  Timeline,
  Row,
  Col,
  Transfer,
  Modal,
  message,
  Popconfirm,
  Skeleton,
  ConfigProvider,
  Comment,
  Descriptions,
  Empty,
  Result,
  FormModel,
  Mentions,
  Statistic,
} from "ant-design-vue";
// import VueVirtualScroller from "vue-virtual-scroller";

import "./registerServiceWorker";

import { createProvider } from "./vue-apollo";

// Vue.use(VueVirtualScroller);

Vue.use(BootstrapVue);
Vue.use(Skeleton);
Vue.use(Avatar);
Vue.use(Popconfirm);
Vue.use(Transfer);
Vue.use(Modal);
Vue.use(Divider);
Vue.use(Row);
Vue.use(Col);
Vue.use(Timeline);
Vue.use(Tree);
Vue.use(Popover);
Vue.use(List);
Vue.use(Card);
Vue.use(Button);
Vue.use(Rate);
Vue.use(TreeSelect);
Vue.use(Breadcrumb);
Vue.use(Layout);
Vue.use(Table);
Vue.use(Icon);
Vue.use(Progress);
Vue.use(Radio);
Vue.use(Dropdown);
Vue.use(Menu);
Vue.use(Carousel);
Vue.use(Input);
Vue.use(Calendar);
Vue.use(Badge);
Vue.use(Slider);
Vue.use(Form);
Vue.use(Tooltip);
Vue.use(Select);
Vue.use(Tag);
Vue.use(Affix);
Vue.use(Spin);
Vue.use(Alert);
Vue.use(Checkbox);
Vue.use(Tabs);
Vue.use(Pagination);
Vue.use(Upload);
Vue.use(Message);
Vue.use(Steps);
Vue.use(InputNumber);
Vue.use(Drawer);
Vue.use(Switch);
Vue.use(Cascader);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Anchor);
Vue.use(AutoComplete);
Vue.use(Collapse);
Vue.use(BackTop);
Vue.use(ConfigProvider);
Vue.use(Comment);
Vue.use(Descriptions);
Vue.use(Empty);
Vue.use(Result);
Vue.use(FormModel);
Vue.use(Mentions);
Vue.use(Statistic);

Vue.prototype.$notification = notification;
Vue.prototype.$message = message;

Vue.use(NProgress);
Vue.use(VuePageTitle, {
  // prefix: "ICT24H | ",
  suffix: "- ICT24H App ",
  router,
});

Vue.config.productionTip = false;
const nprogress = new NProgress({ parent: "body" });

import VueEditor from "vue2-editor";

Vue.use(VueEditor);

// Check Auth here firt router run
store.dispatch("auth/init");

export const apolloProvider = createProvider();

import filters from "./filters";
import "./global.scss";
new Vue({
  router,
  store,
  nprogress,
  i18n,
  apolloProvider,
  render: (h) => h(App),
  filters,
}).$mount("#app");
